const sexOptions = [
    { value: 'unknown', label: { en: 'Unknown', es: 'Desconocido' } },
    { value: 'male', label: { en: 'Male', es: 'Macho' } },
    { value: 'female', label: { en: 'Female', es: 'Hembra' } },
];

export default sexOptions;